import SlickForScreenshots from "./SlickForSceenshots";
const BoxContentNotGroup = ({data})  => {
    let content = null;

    // Switch statement outside JSX to handle content based on item.cc_box_content_alignment
    switch (data.cc_box_content_width) {
        case '50':
            content = (
                <div className="process-panels-container tram-hts-container-two-col">
                    <div className="process-panel tram-hts-panel">
                        <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                        {data.imageUrl.length > 1? (
                            <div className="tram-hts-image-slider-section ">
                                <div className="container">
                                <SlickForScreenshots screenshotContent={data.imageUrl}  dataSettings={50}/>
                                </div>
                        </div>
                        ):(
                            <div className="tram-hts-image-section">
                                <img src={data.imageUrl} alt={data.cc_box_content_title} className="tram-hts-two-col-image" />
                            </div> 
                        )}
                        <p className="process-desc tram-hts-two-col-content">{data.cc_box_content_content}</p>
                    </div>
                </div>
            );
            break;
        case '100':
            // Switch statement outside JSX to handle content based on item.cc_box_content_alignment
            switch (data.cc_box_content_alignment) {
                case 'bottom':
                    content = (
                        <div className="process-panels-container tram-hts-container-one-col">
                            <div className="process-panel tram-hts-panel">
                                <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                                <div className="tram-hts-image-section tram-hts-multiple-images">
                                    {Array.isArray(data.imageUrl) && data.imageUrl.slice(0, 5).map((img, i) => (
                                        <img key={i} src={img} alt="" />
                                    ))}
                                </div>
                                {data.imageUrl.length > 1? (
                                    <div className="tram-hts-image-slider  tram-hts-image-slider-section">
                                        <div className="container">
                                        <SlickForScreenshots screenshotContent={data.imageUrl} dataSettings={null} />
                                        </div>
                                    </div>
                                ):(
                                    <div className="tram-hts-image-slider tram-hts-image-section">
                                        <img src={data.imageUrl}  />
                                    </div>
                                )}
                                
                                <p className="process-desc tram-hts-one-col-content">{data.cc_box_content_content}</p>
                            </div>
                        </div>
                    );
                    break;
                    case 'right':
                    content = (
                        <div className="process-panels-container tram-hts-container-one-col">
                            <div className="process-panel tram-hts-panel-horizontal">
                                <div className="tram-half-width">
                                {data.imageUrl.length > 2?(
                                    <div className="tram-hts-image-slider-section">
                                        <div className="container">
                                            <SlickForScreenshots screenshotContent={data.imageUrl} dataSettings={'left'} />
                                        </div>
                                    </div>
                                ):(
                                    <div className="tram-hts-image-section tram-hts-multiple-images">
                                        {Array.isArray(data.imageUrl) && data.imageUrl.slice(0, 2).map((img, i) => (
                                            <img key={i} src={img} alt="" />
                                        ))}
                                    </div>
                                 )}
                                    
                                </div>
                                <div className="tram-half-width tram-margin-auto">
                                    <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                                    <p className="process-desc tram-hts-one-col-content tram-hts-one-col-content-horizontal">
                                        {data.cc_box_content_content}
                                    </p>
                                </div>
                            </div>
                            <div className="process-panel tram-hts-panel-vertical">
                                <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                                {data.imageUrl.length > 1? (
                                    <div className="tram-hts-image-slider">
                                        <div className="container">
                                            <SlickForScreenshots screenshotContent={data.imageUrl} dataSettings={null} />
                                        </div>
                                    </div>
                                ):(
                                    <div className="tram-hts-image-slider tram-hts-image-section">
                                        <img src={data.imageUrl}  />
                                    </div> 
                                )}
                                
                                <p className="process-desc tram-hts-one-col-content">{data.cc_box_content_content}</p>
                            </div>
                        </div>
                    );
                    break;
                case 'left':
                    content = (
                        <div className="process-panels-container tram-hts-container-one-col">
                            <div className="process-panel tram-hts-panel-horizontal">
                                <div className="tram-half-width tram-margin-auto">
                                    <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                                    <p className="process-desc tram-hts-one-col-content tram-hts-one-col-content-horizontal">
                                        {data.cc_box_content_content}
                                    </p>
                                </div>
                                <div className="tram-half-width">
                                {data.imageUrl.length > 2?(
                                    <div className="tram-hts-image-slider-section">
                                        <div className="container">
                                            <SlickForScreenshots screenshotContent={data.imageUrl} dataSettings={'left'} />
                                        </div>
                                    </div>
                                ):(
                                    <div className="tram-hts-image-section tram-hts-multiple-images">
                                        {Array.isArray(data.imageUrl) && data.imageUrl.slice(0, 2).map((img, i) => (
                                            <img key={i} src={img} alt="" />
                                        ))}
                                    </div>
                                 )}
                                    
                                </div>
                            </div>
                            <div className="process-panel tram-hts-panel-vertical">
                                <h2 className="process-name tram-hts-heading">{data.cc_box_content_title}</h2>
                                {data.imageUrl.length > 1? (
                                    <div className="tram-hts-image-slider">
                                        <div className="container">
                                            <SlickForScreenshots screenshotContent={data.imageUrl} dataSettings={null} />
                                        </div>
                                    </div>
                                ):(
                                    <div className="tram-hts-image-slider tram-hts-image-section">
                                        <img src={data.imageUrl}  />
                                    </div> 
                                )}
                                
                                <p className="process-desc tram-hts-one-col-content">{data.cc_box_content_content}</p>
                            </div>
                        </div>
                    );
                    break;
                default:
                   return null;
                    // break;
            
            }
            break;
        default:
            // content = null;
            // break;
            return null;
    }

    
    return(
  
        <section className="processes box-content text-center p-top-70">
            <div className="container">
                {content}
            </div>
        </section>                      
                 
    );
}

export default BoxContentNotGroup;